import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useQuery } from '@apollo/client';

import PriceLabel from '@components/PriceLabel';

import messages from '../messages';

import { IModalSubHeader } from './model';
import {
  getProductById,
  getProductByIdVariables,
} from './queries/__generated__/getProductById';
import getProductByIdQuery from './queries/productById.graphql';
import {
  SubHeaderWrapper,
  SubHeader,
  InlineBlock,
  PriceWrapper,
  CurrencyWrapper,
  Notes,
} from './styled';

export const ModalSubHeader: React.FC<IModalSubHeader> = ({
  amount,
  statusMessages,
  productId,
}) => {
  const { loading, error, data } = useQuery<
    getProductById,
    getProductByIdVariables
  >(getProductByIdQuery, {
    variables: {
      id: productId.toString(),
    },
  });

  if (loading || error || !data || !data.vpProductById) {
    return null;
  }

  const { vpProductById } = data;
  const priceSum = {
    ...vpProductById.price,
    value: vpProductById.price.value * amount,
  };
  return (
    <SubHeaderWrapper>
      <SubHeader data-cypress="addToCartModal-productInfo">
        {vpProductById.brand && vpProductById.brand.name}{' '}
        <strong>{vpProductById.name}</strong> {vpProductById.annotation}{' '}
        <InlineBlock data-cypress="addToCartModal-priceInfo">
          | {amount} {vpProductById.orderUnit} |{' '}
          <PriceLabel
            price={priceSum}
            wrapperComponent={PriceWrapper}
            currencyComponent={CurrencyWrapper}
          />
        </InlineBlock>
      </SubHeader>
      {statusMessages && (
        <Notes>
          {statusMessages.map((messageKey) => (
            <div key={messageKey} data-cypress="addToCartModal-statusMessage">
              <FormattedMessage {...messages[messageKey]} />
            </div>
          ))}
        </Notes>
      )}
    </SubHeaderWrapper>
  );
};
